import { render, staticRenderFns } from "./SettingPassword.vue?vue&type=template&id=906b71e0&scoped=true&"
import script from "./SettingPassword.vue?vue&type=script&lang=js&"
export * from "./SettingPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906b71e0",
  null
  
)

export default component.exports